import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoughSurface = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20z" }), /* @__PURE__ */ _jsx("path", { d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20z" })]
});
export default SvgRoughSurface;
